export default {
    "name": "ProductTitleData",
    "kind": "HoudiniQuery",
    "hash": "f74f62114d717a2f4dd1aa0acd9c63d4f2e591a78bf33bf78bc5256565d40724",

    "raw": `query ProductTitleData($handle: String, $language: LanguageCode!) @inContext(language: $language) {
  product(handle: $handle) {
    id
    title
    collections(first: 1) {
      edges {
        node {
          path: metafield(key: "path", namespace: "sprenger") {
            key
            value
            id
          }
          id
        }
      }
    }
  }
}
`,

    "rootType": "QueryRoot",

    "selection": {
        "fields": {
            "product": {
                "type": "Product",
                "keyRaw": "product(handle: $handle)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "collections": {
                            "type": "CollectionConnection",
                            "keyRaw": "collections(first: 1)",

                            "selection": {
                                "fields": {
                                    "edges": {
                                        "type": "CollectionEdge",
                                        "keyRaw": "edges",

                                        "selection": {
                                            "fields": {
                                                "node": {
                                                    "type": "Collection",
                                                    "keyRaw": "node",

                                                    "selection": {
                                                        "fields": {
                                                            "path": {
                                                                "type": "Metafield",
                                                                "keyRaw": "path(key: \"path\", namespace: \"sprenger\")",
                                                                "nullable": true,

                                                                "selection": {
                                                                    "fields": {
                                                                        "key": {
                                                                            "type": "String",
                                                                            "keyRaw": "key",
                                                                            "visible": true
                                                                        },

                                                                        "value": {
                                                                            "type": "String",
                                                                            "keyRaw": "value",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "ID",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "handle": "String",
            "language": "LanguageCode"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=02aa4831af7174d78788f587bda710f289646cfde6f816e5d660dee67130b4a3";